// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d3-2";
export var aiChatCartContainerExit = "_d3-4";
export var aiChatContainerLarge = "_d3-0";
export var aiChatContainerSmall = "_d3-1";
export var aiChatIcon = "_d3-6";
export var slideInFromRight = "_d3-3";
export var slideOutToRight = "_d3-5";